import ReactGa from 'react-ga';
import APP from 'app';

const { Utils } = APP,
    {getConfig} = Utils,
    {trackingId=""}=getConfig();

class ga  {

     initGa=()=>{
        ReactGa.initialize(trackingId, {
          })
    }
    GaPageView=(path)=>{
        ReactGa.pageview(path)
    }
     GaEvent=(cat,act)=>{
        ReactGa.event({
            category:cat,
            action:act
        })
    }
}
const GA = new ga();
Object.freeze(GA);
export default GA